import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-65">
      <div className="container mx-auto px-4" data-id="element-66">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-67">
          <div className="mb-6 md:mb-0" data-id="element-68">
            <a href="#" className="text-2xl font-bold text-white" data-id="element-69">
              Vaxtech Group SAS
            </a>
            <p className="mt-2 text-gray-400 max-w-md" data-id="element-70">
              Soluciones digitales integrales para impulsar el crecimiento de tu
              negocio.
            </p>
          </div>
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-12" data-id="element-71">
            <div data-id="element-72">
              <h4 className="font-semibold mb-3 text-gray-300" data-id="element-73">
                Enlaces rápidos
              </h4>
              <ul className="space-y-2" data-id="element-74">
                <li data-id="element-75">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-76">
                    Inicio
                  </a>
                </li>
                <li data-id="element-77">
                  <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-78">
                    Servicios
                  </a>
                </li>
                <li data-id="element-79">
                  <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-80">
                    Sobre Nosotros
                  </a>
                </li>
                <li data-id="element-81">
                  <a href="https://wa.me/5491150026793" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-82">
                    Contacto
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-83">
              <h4 className="font-semibold mb-3 text-gray-300" data-id="element-84">Servicios</h4>
              <ul className="space-y-2" data-id="element-85">
                <li data-id="element-86">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-87">
                    Diseño web
                  </a>
                </li>
                <li data-id="element-88">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-89">
                    Marketing digital
                  </a>
                </li>
                <li data-id="element-90">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-91">
                    Branding
                  </a>
                </li>
                <li data-id="element-92">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-93">
                    Automatización
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center" data-id="element-94">
          <p className="text-gray-400 text-sm" data-id="element-95">
            © 2025 Vaxtech Group SAS – Todos los derechos reservados.
          </p>
          <div className="mt-4 md:mt-0" data-id="element-96">
            <ul className="flex space-x-6" data-id="element-97">
              <li data-id="element-98">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-99">
                  Política de privacidad
                </a>
              </li>
              <li data-id="element-100">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-101">
                  Términos y condiciones
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>;
}